(() => {

  if(document.querySelector('#productVariantsInfo')){
    let variantInfo = document.querySelector('script#productVariantsInfo').textContent;
    let jsonInfo = JSON.parse(variantInfo);

    let threshold = 10; // default threshold qty
    if(document.querySelector('#thresholdQty')){
      threshold = document.querySelector('#thresholdQty').dataset.threshold; // threshold qty
    }

    let lowInventoryMsg1 = "Low inventory: Only a few left! ";
    let lowInventoryMsg2 = "Low inventory: Last one! ";
    let lowInventoryMsg3 = "Low inventory: refilling soon! ";
    if(document.querySelector('#low_inv_msg1') && document.querySelector('#low_inv_msg1').dataset.msg.trim() !== ''){
      lowInventoryMsg1 = document.querySelector('#low_inv_msg1').dataset.msg;
    }
    if(document.querySelector('#low_inv_msg2') && document.querySelector('#low_inv_msg2').dataset.msg.trim() !== ''){
      lowInventoryMsg2 = document.querySelector('#low_inv_msg2').dataset.msg;
    }
    if(document.querySelector('#low_inv_msg3') && document.querySelector('#low_inv_msg3').dataset.msg.trim() !== ''){
      lowInventoryMsg3 = document.querySelector('#low_inv_msg3').dataset.msg;
    }

    // show low inventory msg
    function lowInventoryMsg(stockMsg) {
      if(document.querySelector('#lowStockMsg1')){
        document.querySelector('#lowStockMsg1').innerHTML = stockMsg;
      } else {
        const lowStockMsgDiv = document.createElement('div');
        lowStockMsgDiv.id = 'lowStockMsg1';
        lowStockMsgDiv.classList.add('lowStockMsg');
        lowStockMsgDiv.textContent = stockMsg;
        document.querySelector('product-info variant-radios').appendChild(lowStockMsgDiv);
      }
      if(document.querySelector('#lowStockMsg2')){
        document.querySelector('#lowStockMsg2').innerHTML = stockMsg;
      } else {
        const lowStockMsgDiv = document.createElement('div');
        lowStockMsgDiv.id = 'lowStockMsg2';
        lowStockMsgDiv.classList.add('lowStockMsg');
        lowStockMsgDiv.textContent = stockMsg;
        document.querySelector('.product-form__buttons-aside').appendChild(lowStockMsgDiv);
      }
    }

    // Function to display messages based on inventory
    function displayInventoryMessages(prods, threshold) {
      prods.forEach(function(prod) {
        document.querySelectorAll(`.product-form__input-inner input[type="radio"]`).forEach((optn) => {
          optn.classList.remove('highlightRed');
        });
        if (prod.inventory_quantity < threshold && prod.inventory_quantity > 1) {
          // show msg
          lowInventoryMsg(lowInventoryMsg1);
          document.querySelectorAll(`.product-form__input-inner input[type="radio"]:checked`).forEach((optn) => {
            optn.classList.add('highlightRed');
          });
        } else if (prod.inventory_quantity == 1) {
          // show msg
          lowInventoryMsg(lowInventoryMsg2);
          document.querySelectorAll(`.product-form__input-inner input[type="radio"]:checked`).forEach((optn) => {
            optn.classList.add('highlightRed');
          });
        } else if (prod.inventory_quantity == 0) {
          // Hide the message if inventory is greater than or equal to threshold
          let stockMsg = '';
          lowInventoryMsg(stockMsg);
          document.querySelectorAll(`.product-form__input-inner input[type="radio"]`).forEach((optn) => {
            optn.classList.remove('highlightRed');
          });
        } else {
          let stockMsg = '';
          lowInventoryMsg(stockMsg);
          document.querySelectorAll(`.product-form__input-inner input[type="radio"]`).forEach((optn) => {
            optn.classList.remove('highlightRed');
          });
        }
      });
    }

    // Function to run when the value of the input element changes
    function handleInputChange() {
      let inputElement = document.querySelector('input[type="hidden"][name="id"]');
      let inputValue = parseInt(inputElement.value, 10);

      // recheck the new info
      let variantInfo = document.querySelector('script#productVariantsInfo').textContent;
      let jsonInfo = JSON.parse(variantInfo);

      // Find the product with the matching ID
      let prod = jsonInfo.find(function(item) {
        return item.id == inputValue;
      });

      // Display inventory messages for the matched product
      if (prod) {
        displayInventoryMessages([prod], threshold);
      }
    }

    // Add event listener to input element
    document.querySelector('input[name="id"]').addEventListener('change', handleInputChange);
    handleInputChange(); // calling function by default
  }
  document.addEventListener('click', (event) => {
    const colorLinks = event.target.closest('color-links');

    if (colorLinks != null) {
      if (event.target.classList.contains('js-product-swatch')) {
        event.preventDefault();

        const swatchLink = event.target;

        let linkURL = swatchLink.dataset.href;
        if (window.location.href.includes('collections/')) {
          const collectionName = `collections/${window.location.href.split('collections/')[1].split('/')[0]}`;
          linkURL = linkURL.replace('collections/all', collectionName);
        }
        const shopURL = swatchLink.dataset.shop;
        const sectionId = swatchLink.closest('color-links').dataset.sectionId;
        const productTitle = swatchLink.dataset.title;
        const url = `${shopURL}${linkURL}`;
        const variantSectionUrl = `${linkURL}/?section_id=${sectionId}`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            document.dispatchEvent(new CustomEvent('pdp:swatch:change', {
              detail: {
                "handle": event.target.dataset.handle
              }
            }));

            history.pushState({}, productTitle, url);

            const new_html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.product').innerHTML;
            const new_upsellElement = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.upsell');

            if (new_upsellElement) {
              const new_upsell = new_upsellElement.innerHTML;
              const upsell_element = document.querySelector('.upsell');
              if(upsell_element) {
                upsell_element.innerHTML = new_upsell;
              }
            }

            document.querySelector('.product').innerHTML = new_html
            document.querySelector('.product color-links').innerHTML = colorLinks.innerHTML

            const allNewLinks = document.querySelectorAll('.product color-links li');
            const currentID = swatchLink.closest('li').querySelector('img').dataset.id;

            allNewLinks.forEach(newLink => {
              if (newLink.querySelector('img').dataset.id === currentID) {
                newLink.querySelector('input').checked = true;
              }
            });

            // for low inventory message
            let new_jsonInfo = new DOMParser().parseFromString(responseText, 'text/html').querySelector('#productVariantsInfo').innerHTML;

            if (new_jsonInfo) {
              let new_jsonInfoParsed = JSON.parse(new_jsonInfo);
              document.querySelector('#productVariantsInfo').innerHTML = new_jsonInfo;

              if (document.querySelector('#productVariantsInfo')) {
                document.querySelector('input[name="id"]').addEventListener('change', handleInputChange); // for input name="id" change value
                handleInputChange(); // handle default selection
              }
            }
          });
      }
    }
  });

})();